import Image from 'next/image';
import Link from 'next/link';
import React from 'react';

import assetLoader from '@/utils/asset-loader';
import styles from './footer.module.scss';

const Footer: React.FC = () => {
    return (
        <footer className={styles.footer}>
            <div
                className={styles.backToTop}
                onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
            >
                <div className={styles.backToTopText}>Back to top</div>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="38"
                    height="38"
                    viewBox="0 0 38 38"
                    fill="none"
                >
                    <circle
                        cx="18.8162"
                        cy="19"
                        r="12.5553"
                        transform="rotate(-45 18.8162 19)"
                        strokeWidth="1.5"
                    />
                    <path d="M19.53 13.4697C19.2371 13.1768 18.7622 13.1768 18.4693 13.4697L13.6963 18.2426C13.4034 18.5355 13.4034 19.0104 13.6963 19.3033C13.9892 19.5962 14.4641 19.5962 14.757 19.3033L18.9996 15.0607L23.2423 19.3033C23.5352 19.5962 24.01 19.5962 24.3029 19.3033C24.5958 19.0104 24.5958 18.5355 24.3029 18.2426L19.53 13.4697ZM18.9996 14L18.2496 14L18.2496 24L18.9996 24L19.7496 24L19.7496 14L18.9996 14Z" />
                </svg>
            </div>
            <div className={styles.footerContainer}>
                <div className={styles.linksGrid}>
                    <div className={styles.logoContainer}>
                        <Link href="/" target="_blank">
                            <Image
                                className={styles.logo}
                                src="/ci/images/landing/icons/udemy-logo-white.svg"
                                alt="Udemy"
                                width={96}
                                height={32}
                            />
                        </Link>
                    </div>
                    <div className={styles.languageContainer}>
                        <span className={styles.language}>EN</span>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                        >
                            <path
                                d="M10.7074 1.71436C5.97596 1.71436 2.14453 5.55436 2.14453 10.2858C2.14453 15.0172 5.97596 18.8572 10.7074 18.8572C15.4474 18.8572 19.2874 15.0172 19.2874 10.2858C19.2874 5.55436 15.4474 1.71436 10.7074 1.71436ZM16.6474 6.85721H14.1188C13.8445 5.78578 13.4502 4.75721 12.936 3.80578C14.5131 4.34578 15.8245 5.44293 16.6474 6.85721ZM10.716 3.46293C11.4274 4.4915 11.9845 5.6315 12.3531 6.85721H9.07882C9.44739 5.6315 10.0045 4.4915 10.716 3.46293ZM4.08167 12.0001C3.94453 11.4515 3.85882 10.8772 3.85882 10.2858C3.85882 9.69436 3.94453 9.12007 4.08167 8.5715H6.97882C6.91024 9.13721 6.85882 9.70293 6.85882 10.2858C6.85882 10.8686 6.91024 11.4344 6.97882 12.0001H4.08167ZM4.78453 13.7144H7.3131C7.58739 14.7858 7.98167 15.8144 8.49596 16.7658C6.91882 16.2258 5.60739 15.1372 4.78453 13.7144ZM7.3131 6.85721H4.78453C5.60739 5.43436 6.91882 4.34578 8.49596 3.80578C7.98167 4.75721 7.58739 5.78578 7.3131 6.85721ZM10.716 17.1086C10.0045 16.0801 9.44739 14.9401 9.07882 13.7144H12.3531C11.9845 14.9401 11.4274 16.0801 10.716 17.1086ZM12.7217 12.0001H8.71025C8.6331 11.4344 8.5731 10.8686 8.5731 10.2858C8.5731 9.70293 8.6331 9.12864 8.71025 8.5715H12.7217C12.7988 9.12864 12.8588 9.70293 12.8588 10.2858C12.8588 10.8686 12.7988 11.4344 12.7217 12.0001ZM12.936 16.7658C13.4502 15.8144 13.8445 14.7858 14.1188 13.7144H16.6474C15.8245 15.1286 14.5131 16.2258 12.936 16.7658ZM14.4531 12.0001C14.5217 11.4344 14.5731 10.8686 14.5731 10.2858C14.5731 9.70293 14.5217 9.13721 14.4531 8.5715H17.3502C17.4874 9.12007 17.5731 9.69436 17.5731 10.2858C17.5731 10.8772 17.4874 11.4515 17.3502 12.0001H14.4531Z"
                                fill="#F7F9FA"
                            />
                        </svg>
                    </div>
                </div>

                <div className={styles.bottomSection}>
                    <div className={styles.socialLinks}>
                        <Link href="https://www.instagram.com/udemy/" target="_blank">
                            <div className="perspective">
                                <button className={styles.socialButton}>
                                    <div
                                        className={styles.instagram}
                                        style={{
                                            maskImage: `url(${assetLoader({src: '/ci/images/landing/icons/insta.svg'})})`,
                                        }}
                                    ></div>
                                </button>
                            </div>
                        </Link>
                        <Link href="https://www.facebook.com/udemy/" target="_blank">
                            <div className="perspective">
                                <button className={styles.socialButton}>
                                    <div
                                        className={styles.facebook}
                                        style={{
                                            maskImage: `url(${assetLoader({src: '/ci/images/landing/icons/fb.svg'})})`,
                                        }}
                                    ></div>
                                </button>
                            </div>
                        </Link>
                        <Link href="https://www.linkedin.com/company/udemy/" target="_blank">
                            <div className="perspective">
                                <button className={`${styles.socialButton} right`}>
                                    <div
                                        className={styles.linkedin}
                                        style={{
                                            maskImage: `url(${assetLoader({src: '/ci/images/landing/icons/linkedin.svg'})})`,
                                        }}
                                    ></div>
                                </button>
                            </div>
                        </Link>
                    </div>
                    <p className={styles.copyright}>© 2025 Udemy, Inc.</p>
                </div>
            </div>
        </footer>
    );
};

export {Footer};
